module.exports = __webpack_public_path__ + "static/media/5DPO10.65503132.jpg";